import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const RouteRenderer = () => {
  const { pathname } = useLocation();
  return (
    <>
      <pre style={{ display: 'inline-block' }}>
        <b>Route:</b> {pathname}
      </pre>
      {pathname !== '/' && (
        <div style={{ display: 'inline-block', marginLeft: 16 }}>
          <Link to="/">return to /</Link>
        </div>
      )}
    </>
  );
};
